import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

import { faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFile } from '@fortawesome/free-solid-svg-icons'; 

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'portafolio ' + environment.env;
  readonly faLinkedinIn = faLinkedinIn;
  readonly faEnvelope = faEnvelope;
  readonly faGithub = faGithub;
  readonly faFile = faFile;
}
